<template>
    <main class="login-container">
        <h1>{{translate('login')}}</h1>
        <form method="post"
              action="/login"
              class="login-form">
            <div class="input-container">
                <label>
                    <span class="icon-envelope"></span>
                    <input v-model="emailInputValue"
                           name="email-input"
                           :placeholder="translate('email')"
                           type="email"
                           autocomplete="off"/>
                </label>
            </div>
            <div class="input-container">
                <label>
                    <span class="icon-padlock"></span>
                    <input v-model="passwordInputValue"
                           name="password-input"
                           :placeholder="translate('password')"
                           type="password"
                           autocomplete="off"/>
                </label>
            </div>
            <div class="navi-btns">
                <span @click="$router.go(-1)" class="back-btn circle-btn"></span>
                <button @click.prevent.stop="tryLogin" class="login-btn">{{translate("log_in")}}</button>
            </div>
            <button type="button" @click="showModal" class="password_reminder">{{translate('forgot_password')}}</button>
            <modal_reminder v-show="isModalVisible"
                            @close="closeModal">

            </modal_reminder>
        </form>
        <router-link to="/register" class="register-link">
            <span class="text">{{translate('no_account')}}</span>
        </router-link>
    </main>
</template>

<script>
    import Modal from "../components/ResultForm/modal";
    import Modal_reminder from "../components/password_reminder/modalReminder";
    export default {
        name: "Login",
        components: {Modal_reminder, Modal},
        data() {
            return {
                emailInputValue: '',
                passwordInputValue: '',
                isModalVisible: false,
            }
        },
        methods: {

            showModal() {
                this.isModalVisible = true;
            },

            closeModal() {
                this.isModalVisible = false;
            },

            translate(code) {
                let arg = {
                    type: 'translate',
                    code: code,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;
            },

            getFormData() {
                let form = new FormData();
                form.append('email', this.emailInputValue);
                form.append('password', this.passwordInputValue);
                return form;
            },

            tryLogin() {
                this.$apiController.loginUser(this.getFormData())
                    .then((res) => {
                        if (res.status === 'success') {
                            localStorage.userApplicationToken = res.data.token;
                            localStorage.userEmail = res.data.email;
                            localStorage.userDiscountValue = res.data.discount_value;
                            localStorage.userRole = res.data.role;
                            localStorage.userId = res.data.userId;
                            localStorage.userCompany = res.data.company;
                            this.$notifications.add(this.$notifications.TYPES.NOTIFICATION, this.translate('notification_success'), this.translate('login_success'));
                            this.$store.state.isUserLogged = true;
                            this.$store.state.userRole = res.data.role;
                            this.$store.state.userEmail = res.data.email;
                            this.$store.state.discount.userDiscountValue = res.data.discount_value;
                            this.$store.state.userId = res.data.userId;
                            this.$store.state.userCompany = res.data.company;
                            this.$apiController.getVariablesFullList()
                                .then((res) => {
                                    if (res.status === 'success')
                                        this.$store.state.appVariables = res.data;
                                });
                            this.$apiController.getPricesList()
                                .then((res) => {
                                    if (res.status === 'success')
                                        this.$store.state.pricesList = res.data;
                                });

                            this.$store.state.lastPathParameters = {
                                selectedFirstStepElement: null,
                                selectedSecondStepElement: null,
                                selectedThirdStepElement: null
                            };

                            this.$router.push('/');
                        } else if (res.status === 'error') {
                            localStorage.userApplicationToken = '';
                            localStorage.userEmail = '';
                            localStorage.userDiscountValue = 0;
                            localStorage.userRole = '';
                            localStorage.userCompany = '';

                            this.$notifications.add(this.$notifications.TYPES.WARNING, this.translate('authorization_error'), this.translate(res.message))
                        }
                    })
                    .catch((error) => {
                        throw new Error(error);
                    });
            }
        }
    }
</script>

<style scoped>

</style>
